import {
  createApi,
  fetchBaseQuery,
  type BaseQueryFn,
  type FetchArgs,
  type FetchBaseQueryError,
} from "@reduxjs/toolkit/query/react";
import { environment } from "@/shared/config/environment";
import { clearSession, readSession } from "./session";

// In dev il base url e' relativo (/API, proxy Vite): fetch vuole un URL assoluto sia nel browser che in jsdom.
const baseUrl = new URL(String(environment.apiBaseUrl), window.location.origin).toString();

const rawBaseQuery = fetchBaseQuery({
  baseUrl,
  prepareHeaders: (headers) => {
    const { token, apiKey } = readSession();
    if (apiKey) headers.set("X-Accelasearch-Apikey", apiKey);
    if (token) headers.set("X-Accelasearch-Jwt", token);
    return headers;
  },
});

type BackendEnvelope = { status?: unknown } | null | undefined;

/** Quirk del backend: risponde 200 con {status:"ERROR"}; 401/403 chiudono la sessione come l'interceptor axios. */
export const baseQuery: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (
  args,
  api,
  extraOptions,
) => {
  const result = await rawBaseQuery(args, api, extraOptions);
  if (result.error) {
    if (result.error.status === 401 || result.error.status === 403) {
      clearSession();
      // Per tipo, non con l'action creator: shared non importa da features (spec sezione 4).
      api.dispatch({ type: "session/sessionExpired" });
    }
    return result;
  }
  const data = result.data as BackendEnvelope;
  if (data && typeof data === "object" && data.status === "ERROR") {
    return { error: { status: "CUSTOM_ERROR", error: "Il backend ha risposto con status ERROR", data } };
  }
  return result;
};

export const baseApi = createApi({
  reducerPath: "api",
  baseQuery,
  tagTypes: [
    "Shop",
    "Customer",
    "User",
    "Plan",
    "Notifications",
    "Languages",
    "FeatureFlags",
    "ShopAttributes",
    "PaymentMethods",
    "FacetLabels",
    "VisualMachine",
  ],
  endpoints: () => ({}),
});
